import type {
    BaseConfig,
    UrlConfig,
    ModelUrlConfig,
    ModelUrlData,
    MenuConfig
} from '@preload/graphql/getConfig.d'

export enum SubmenuMode {
    BLOCK = 'cms_block',
    SUBCATEGORY = 'subcategory'
}

export enum ModelTypeEnum {
    CATEGORY = 'category',
    PRODUCT = 'product',
    CMS_PAGE = 'cmsPage',
    BLOG = 'blog'
}

export type ModelType = keyof Omit<ModelUrlConfig, '__typename'>

export type FrontendBaseConfig = BaseConfig & {
    url: UrlConfig & {
        baseUrl: string
        magentoBaseUrl: string
        model: {
            [key in ModelType]: ModelUrlData & {
                directory: string
            }
        }
        externalShishaworldurl: string
    }
    menu: Required<Omit<MenuConfig, '__typename'>> & {
        submenu: SubmenuMode | string
    }
    wishlist: {
        enabled: boolean
        multiple_wishlists: boolean
    }
    yotpo: {
        enabled: boolean
        api_key: string
    }
    yotpoLoyalty: {
        enabled: boolean
        guid: string
        widget_ids: {
            checkoutPopup: string
            checkoutRedeem: string
            myAccountPage: string[]
            rewardsPage: string
            referralsPage: string | null
        }
    }
    landingpage: {
        enabled: boolean
    }
    signifyd: {
        enabled: boolean
    }
    loqate: {
        enabled: boolean
        findEndPoint: string
        retrieveEndPoint: string
        validateEndPoint: string
        api_key: string
    }
    spreedlyPaymentMethod: {
        enabled: boolean
        environment_key: string
        scriptLink: string
        sri: string
    }
    klarna: {
        enabled: boolean
        scriptLink: string
        allowedCountries: string[]
    }
    gReCaptcha: {
        token: string
        enabled: boolean
    }
    veratad: {
        enabled: boolean
    }
    vr: {
        enabled: boolean
    }
    reorderAllow: boolean
    // When false, getFastlyUrl skips the image transformation query params
    is_enable_cloudfare_transformation?: boolean
    socialLogin: {
        google: {
            enabled: boolean
            clientId: string
        }
        facebook: {
            enabled: boolean
            appId: string
        }
    }
    restrictedArea: {
        areaCodes: string[]
    }
    sentry?: {
        enabled: boolean
        dsn: string
    }
    paymentWidgets?: {
        tabby?: {
            enabled: boolean
            publicKey: string
        }
        tamara?: {
            enabled: boolean
            publicKey: string
        }
    }
}

export const base: FrontendBaseConfig = {
    url: {
        baseUrl: 'https://hookah-shisha.pwa.corralive.com/',
        magentoBaseUrl: 'https://mcstaging.hookah-shisha.com/',
        model: {
            category: {
                directory: 'category'
            },
            product: {
                suffix: '.html',
                directory: 'product'
            },
            cmsPage: {
                directory: 'content'
            },
            blog: {
                directory: 'blog'
            }
        },
        externalShishaworldurl: 'https://www.shisha-world.com/'
    },
    menu: {
        submenu: SubmenuMode.SUBCATEGORY,
        submenu_maxitems: 10
    },
    wishlist: {
        enabled: true,
        multiple_wishlists: false
    },
    yotpo: {
        enabled: false,
        api_key: ''
    },
    yotpoLoyalty: {
        enabled: false,
        guid: '',
        widget_ids: {
            checkoutPopup: '83952',
            checkoutRedeem: '72483',
            myAccountPage: ['72236', '72233', '72237', '72464', '72234'],
            rewardsPage: '72232',
            referralsPage: '72234'
        }
    },
    signifyd: {
        enabled: false
    },
    landingpage: {
        enabled: false
    },
    loqate: {
        enabled: true,
        findEndPoint:
            'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
        retrieveEndPoint:
            'https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws',
        validateEndPoint:
            'https://api.addressy.com/Cleansing/International/Batch/v1.00/json4.ws',
        api_key: 'BT93-NX41-XE96-XN29'
    },
    spreedlyPaymentMethod: {
        enabled: false,
        environment_key: '',
        scriptLink: 'https://core.spreedly.com/checkout/sdk/1.6.2/index.js',
        sri:
            'sha384-RIyE3OUuYKNGQTpBRH1lHnuedS6yrvAlQEmprA2tgC4owK+gTfWqFr+8zEMiZN/N'
    },
    klarna: {
        enabled: false,
        scriptLink: 'https://x.klarnacdn.net/kp/lib/v1/api.js',
        allowedCountries: ['DE']
    },
    gReCaptcha: {
        token: '',
        enabled: true
    },
    vr: {
        enabled: false
    },
    veratad: {
        enabled: false
    },
    reorderAllow: false,
    is_enable_cloudfare_transformation: false,
    socialLogin: {
        google: {
            enabled: false,
            clientId: ''
        },
        facebook: {
            enabled: false,
            appId: ''
        }
    },
    restrictedArea: {
        areaCodes: []
    },
    sentry: {
        enabled: false,
        dsn: ''
    }
}

export default base
